import React from "react";
import { Modal } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import "./DreamModal.css";

const DreamModal = ({
  show,
  onHide,
  title,
  children,
  size = "lg",
  centered = true,
  showCloseButton = true,
  className = "",
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size}
      centered={centered}
      className={`dream-modal ${className}`}
      aria-labelledby="dream-modal-title"
      aria-modal="true"
      role="dialog"
    >
      <div className="dream-modal-header" role="banner">
        <h3 id="dream-modal-title">{title}</h3>
        {showCloseButton && (
          <button
            className="close-button"
            onClick={onHide}
            aria-label="Close modal"
            type="button"
          >
            <FaTimes aria-hidden="true" />
          </button>
        )}
      </div>
      <div className="dream-modal-body" role="main">
        {children}
      </div>
    </Modal>
  );
};

export default DreamModal;
